{
  "todaysDashboard": {
    "title": "Tableau de bord"
  },
  "snapshotCards": {
    "needsAction": {
      "title": "Actions requises",
      "secondaryStat": "{{count}} en bonne voie",
      "breakdown": {
        "urgent": "Liquider / Transférer",
        "moderate": "Dérive / Non vérifié(s)",
        "aum": "AUM"
      }
    },
    "tradePipeline": {
      "title": "Flux des transactions",
      "secondaryStat": "transactions en attente",
      "breakdown": {
        "staged": "Préparées",
        "approved": "Approuvées",
        "sent": "Envoyées"
      }
    },
    "opsInFlight": {
      "title": "Opérations en cours",
      "secondaryStat": "opérations",
      "breakdown": {
        "rebalances": "Rééquilibrages",
        "batches": "Lots"
      }
    }
  },
  "tradePipeline": {
    "title": "Flux des transactions",
    "asOfPrefix": "En date du",
    "viewTrades": "Voir les transactions →",
    "totalOutstanding": "FLUX DES TRANSACTIONS — {{total}} EN SUSPENS AU TOTAL",
    "errorPrefix": "Erreur :",
    "emptyBar": "Aucune transaction en suspens",
    "staged": {
      "title": "Préparées",
      "description": "En attente d'approbation"
    },
    "approved": {
      "title": "Approuvées",
      "description": "Prêtes à être envoyées"
    },
    "sent": {
      "title": "Envoyées",
      "description": "Soumises aux dépositaires"
    }
  },
  "operations": {
    "activeTitle": "OPÉRATIONS ACTIVES ({{count}})",
    "emptyTitle": "Aucune opération active",
    "emptyDescription": "Les rééquilibrages et les lots de transactions apparaîtront ici lorsqu'ils seront en cours",
    "optimizerPortfolios": "{{count}} portefeuilles",
    "bulkTradeRun": "Exécution de transactions en bloc"
  },
  "deepLink": {
    "missingObjectId": "Ce portefeuille n'a pas pu être entièrement chargé — les données détaillées peuvent être incomplètes."
  },
  "filters": {
    "searchPortfolios": "Rechercher des portefeuilles...",
    "searchTickers": "Rechercher des symboles boursiers...",
    "searchModels": "Rechercher des modèles...",
    "needsRebalance": "Nécessite un rééquilibrage",
    "drift": "Dérive",
    "transfer": "Transfert",
    "liquidation": "Liquidation",
    "trading": "Négociation",
    "allTypes": "Tous les types",
    "goals": "Objectifs",
    "subAccounts": "Sous-comptes",
    "allModels": "Tous les modèles",
    "modelSearchPlaceholder": "Rechercher des modèles...",
    "clear": "Effacer",
    "rebalanceStarted_one": "Le rééquilibrage de {{count}} portefeuille a été lancé. Consultez la progression dans l'onglet Opérations actives.",
    "rebalanceStarted_other": "Le rééquilibrage de {{count}} portefeuilles a été lancé. Consultez la progression dans l'onglet Opérations actives.",
    "optimizePartialSuccess": "{{succeeded}} des {{total}} optimisations ont été lancées; {{failed}} ont échoué.",
    "optimizeAllFailed": "Toutes les optimisations ont échoué. Veuillez réessayer.",
    "downloadAllSelected": "Télécharger tous les éléments sélectionnés",
    "modelSearchFailed": "La recherche de modèle a échoué. Veuillez réessayer.",
    "portfolioSearchFailed": "La recherche de portefeuille a échoué. Veuillez réessayer.",
    "exposureSearchFailed": "La recherche de symbole boursier a échoué. Veuillez réessayer.",
    "allStatuses": "Toutes les raisons"
  },
  "portfoliosTable": {
    "pageLoadErrorTitle": "Le chargement de cette page a échoué.",
    "pageLoadErrorDescription": "Le serveur a renvoyé une violation de non-null GraphQL pour une ou plusieurs lignes de la page {{page}}, par conséquent, la charge utile de la page entière a été abandonnée. D'autres pages pourraient encore fonctionner.",
    "retryThisPage": "Réessayer cette page",
    "goBackPage": "Retourner à la page précédente",
    "noPortfoliosFound": "Aucun portefeuille trouvé.",
    "adjustFiltersHint": "Essayez d'ajuster vos filtres.",
    "noDataAvailable": "Aucune donnée disponible.",
    "unresolvedRows_one": "{{count}} portefeuille de cette page n'a pas pu être chargé.",
    "unresolvedRows_other": "{{count}} portefeuilles de cette page n'ont pas pu être chargés.",
    "columns": {
      "portfolio": "Portefeuille",
      "modelName": "Nom du modèle",
      "reason": "Raison",
      "custodian": "Dépositaire",
      "advisor": "Conseiller",
      "value": "Valeur",
      "cashAndPosition": "Trésorerie et position",
      "lastRebalDate": "Date du dernier rééquilibrage",
      "trades": "Transactions"
    },
    "custodian": {
      "multiple": "Multiple"
    },
    "advisor": {
      "multiple": "Multiple"
    },
    "cashPosition": {
      "cash": "Trésorerie",
      "position": "Position"
    },
    "tradeToasts": {
      "created_one": "{{count}} transaction a été créée avec succès. Visualisez-la dans l'onglet Transactions.",
      "created_other": "{{count}} transactions ont été créées avec succès. Visualisez-les dans l'onglet Transactions.",
      "createFailed": "Échec de la création des transactions. Veuillez réessayer.",
      "noActionable": "Aucune transaction réalisable — toutes les positions sélectionnées sont déjà à la cible ou près de celle-ci.",
      "missingGoalObjectId_one": "{{count}} portefeuille d'objectif a été ignoré car son identifiant de compte est manquant.",
      "missingGoalObjectId_other": "{{count}} portefeuilles d'objectifs ont été ignorés car leurs identifiants de compte sont manquants.",
      "createPartialSuccess": "{{succeeded}} des {{total}} groupes de transactions ont été créés; {{failed}} ont échoué.",
      "createAllFailed": "Échec de la création de toutes les transactions. Veuillez réessayer.",
      "bucketPartialFailure_one": "{{count}} portefeuille n'a pas réussi à regrouper ses nouvelles transactions.",
      "bucketPartialFailure_other": "{{count}} portefeuilles n'ont pas réussi à regrouper leurs nouvelles transactions."
    }
  },
  "portfoliosTab": {
    "fatalError": "Erreur lors du chargement des portefeuilles : {{message}}"
  },
  "title": "Centre de négociation de portefeuilles",
  "titleV2": "Centre de négociation de portefeuilles v2",
  "tabs": {
    "dashboard": "Tableau de bord",
    "portfolios": "Portefeuilles",
    "trades": "Transactions",
    "activeOperations": "Opérations actives"
  },
  "relativeTime": {
    "justNow": "à l'instant",
    "minutesAgo": "il y a {{count}} min",
    "hoursAgo": "il y a {{count}} h",
    "daysAgo": "il y a {{count}} j",
    "updated": "Mis à jour {{time}}"
  },
  "insights": {
    "title": "Aperçus",
    "closeA11y": "Fermer les aperçus",
    "toggleA11y": "Basculer les aperçus",
    "sections": {
      "alerts": "Alertes",
      "suggestions": "Suggestions",
      "info": "Info"
    },
    "footer": {
      "poweredBy": "Propulsé par un moteur de règles"
    },
    "driftAlert": {
      "title_one": "{{count}} portefeuille nécessite une attention",
      "title_other": "{{count}} portefeuilles nécessitent une attention",
      "description": "{{percent}} % des portefeuilles présentent une dérive au-delà de la tolérance, des liquidations en attente ou des rééquilibrages de transferts. Priorisez-les avant la fin de la journée.",
      "action": "Voir les portefeuilles signalés"
    },
    "opsActive": {
      "title_one": "{{count}} opération en cours",
      "title_other": "{{count}} opérations en cours",
      "description": "Les rééquilibrages actifs ou les lots de transactions sont en cours de traitement. Vérifiez s'il y en a qui pourraient être bloqués dans un état intermédiaire.",
      "action": "Surveiller les opérations actives"
    },
    "tradesInFlight": {
      "title_one": "{{count}} transaction dans le flux",
      "title_other": "{{count}} transactions dans le flux",
      "descriptionBulk": "Grand lot de {{count}} transactions actives. Vérifiez les entrées INITIÉES obsolètes.",
      "descriptionDefault": "Les transactions progressent dans le flux. Vérifiez les entrées bloquées ou obsolètes.",
      "action": "Voir les transactions en cours"
    },
    "cashFlowRisk": {
      "title_one": "{{count}} sortie de fonds à risque de découvert",
      "title_other": "{{count}} sorties de fonds à risque de découvert",
      "description": "Retraits en attente dépassant 90 % de la valeur du portefeuille. Pourrait entraîner des découverts ou des liquidations forcées.",
      "action": "Examiner les flux de trésorerie"
    },
    "cashFlowImminent": {
      "title_one": "{{count}} événement de trésorerie dû dans les 24 h",
      "title_other": "{{count}} événements de trésorerie dus dans les 24 h",
      "description": "Transferts prévus pour aujourd'hui ou demain. Vérifiez la liquidité suffisante et l'absence de transactions conflictuelles.",
      "action": "Examiner les flux de trésorerie"
    },
    "cashFlowOverview": {
      "title_one": "{{count}} flux de trésorerie en attente",
      "title_other": "{{count}} flux de trésorerie en attente",
      "description": "{{inflows}}, {{outflows}}. {{outflowAmount}} total des sorties de fonds en attente. Aucun risque immédiat.",
      "descriptionInflows_one": "{{count}} entrée de fonds",
      "descriptionInflows_other": "{{count}} entrées de fonds",
      "descriptionOutflows_one": "{{count}} sortie de fonds",
      "descriptionOutflows_other": "{{count}} sorties de fonds",
      "action": "Voir les détails"
    },
    "allClear": {
      "title": "Tous les systèmes sont nominaux",
      "description_one": "{{count}} portefeuille dans les limites de tolérance. Aucune opération active ou transaction en attente.",
      "description_other": "{{count}} portefeuilles dans les limites de tolérance. Aucune opération active ou transaction en attente."
    },
    "bulkOptimize": {
      "title": "Envisagez l'optimisation en bloc",
      "description": "{{count}} portefeuilles nécessitent un rééquilibrage sans opérations actives. Utilisez la sélection en bloc pour optimiser en un seul lot.",
      "action": "Sélectionner les portefeuilles"
    },
    "settlementCheck": {
      "title": "Vérifier les dates de règlement",
      "description": "Transactions en cours sans opérations actives. Vérifiez que les dates de règlement sont correctes.",
      "action": "Vérifier les transactions"
    }
  },
  "bulkTradeRunStates": {
    "GENERATING": "Préparation des transactions...",
    "BULK_TRADES_INITIATED": "Prêt(s) pour examen",
    "BULK_TRADES_FILES_GENERATING": "Génération des fichiers de transactions...",
    "BULK_TRADES_REQUESTED": "Traitement en cours...",
    "BULK_TRADES_COMPLETED": "Prêt(s) pour l'allocation",
    "ALLOCATIONS_INITIATED": "Préparation des allocations...",
    "ALLOCATIONS_REQUESTED": "Traitement des allocations en cours...",
    "ALLOCATIONS_COMPLETED": "Allocations prêtes",
    "COMPLETED": "Terminé",
    "COMPLETED_PENDING_PTFS": "Transactions PTF en attente",
    "CANCELED": "Annulé"
  },
  "rowDetail": {
    "header": {
      "goalTypeSuffix": " • {{type}}",
      "noModel": "Aucun modèle",
      "subAccountTypeSuffix": " • {{accountType}} (Rang fiscal : {{taxRank}})",
      "multiCcy": "Multi-devises ({{currencies}})",
      "updatedAt": "MAJ : {{date}}"
    },
    "generalInfo": {
      "title": "Informations générales",
      "marketValue": "Valeur marchande",
      "cash": "Trésorerie",
      "targetCash": "Trésorerie cible",
      "drift": "Dérive",
      "pending": "En attente",
      "holdings": "Placements",
      "none": "Aucun",
      "staleActiveTrades": "0 actif(s) (rapport : {{count}} obsolète(s))",
      "activeTradesCount": "{{count}} transactions",
      "driftExceedsThreshold": "Dépasse le seuil",
      "driftMonitor": "Surveiller",
      "driftWithinTolerance": "Dans les limites de tolérance",
      "positionsCount": "{{count}} positions"
    },
    "accountBreakdown": {
      "title": "Ventilation des comptes ({{count}})",
      "type": "Type",
      "client": "Client",
      "marketValue": "Valeur marchande",
      "cashAvailable": "Trésorerie disponible",
      "pendingWithdraw": "Retrait(s) en attente"
    },
    "pendingTrades": {
      "title": "Transactions en attente",
      "titleWithCount": "Transactions en attente ({{count}})",
      "side": "Sens",
      "security": "Titre",
      "amount": "Montant",
      "qty": "Qté",
      "state": "État",
      "created": "Créée",
      "buyCount_one": "{{count}} Achat",
      "buyCount_other": "{{count}} Achats",
      "sellCount_one": "{{count}} Vente",
      "sellCount_other": "{{count}} Ventes",
      "net": "Net : {{value}}",
      "noActiveTrades": "Aucune transaction active trouvée",
      "staleCountWarning": "Le rapport indique {{count}} en attente — ce nombre est obsolète. Les transactions peuvent avoir été annulées, complétées ou rapprochées depuis la dernière actualisation du portefeuille."
    },
    "positions": {
      "title": "Positions ({{count}})",
      "symbol": "Symbole",
      "currency": "Devise",
      "qty": "Qté",
      "price": "Prix",
      "value": "Valeur",
      "currentPct": "% Actuel",
      "targetPct": "% Cible",
      "drift": "Dérive",
      "driftValue": "Dérive $"
    },
    "actions": {
      "viewDetails": "Voir les détails",
      "generateTrades": "Générer les transactions"
    }
  },
  "download": {
    "button": "Télécharger le CSV",
    "all": "Tout télécharger",
    "withFilters": "Télécharger avec filtres",
    "filtersTooltip": "Les filtres de recherche ne sont pas appliqués",
    "progressTitle": "Exportation des portefeuilles",
    "fileNamePrefix": "rapports-portefeuilles",
    "exportHeaders": {
      "portfolioId": "ID du portefeuille",
      "type": "Type",
      "modelPortfolio": "Portefeuille modèle",
      "marketValue": "Valeur marchande",
      "cashAvailable": "Trésorerie disponible",
      "targetCashPercent": "Pourcentage cible de trésorerie",
      "status": "Statut",
      "driftRequired": "Dérive requise",
      "pendingTrades": "Transactions en attente",
      "lastOptimized": "Dernière optimisation"
    }
  },
  "modelPortfolioView": {
    "columns": {
      "model": "Modèle",
      "portfolios": "Nombre de portefeuilles",
      "marketValue": "Valeur totale",
      "avgDrift": "Dérive moyenne",
      "rebalance": "Rééquilibrage",
      "trades": "Transactions",
      "currency": "Devise"
    }
  },
  "tickerView": {
    "columns": {
      "security": "Titre",
      "totalValue": "Valeur totale",
      "totalQty": "Qté totale",
      "portfolios": "Nombre de portefeuilles",
      "pctAum": "% de l'AUM",
      "currency": "Devise"
    }
  }
}
